/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/ 	var parentHotUpdateCallback = this["webpackHotUpdate"];
/******/ 	this["webpackHotUpdate"] = 
/******/ 	function webpackHotUpdateCallback(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		hotAddUpdateChunk(chunkId, moreModules);
/******/ 		if(parentHotUpdateCallback) parentHotUpdateCallback(chunkId, moreModules);
/******/ 	}
/******/ 	
/******/ 	function hotDownloadUpdateChunk(chunkId) { // eslint-disable-line no-unused-vars
/******/ 		var head = document.getElementsByTagName("head")[0];
/******/ 		var script = document.createElement("script");
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = "utf-8";
/******/ 		script.src = __webpack_require__.p + "" + chunkId + "." + hotCurrentHash + ".hot-update.js";
/******/ 		head.appendChild(script);
/******/ 	}
/******/ 	
/******/ 	function hotDownloadManifest(callback) { // eslint-disable-line no-unused-vars
/******/ 		if(typeof XMLHttpRequest === "undefined")
/******/ 			return callback(new Error("No browser support"));
/******/ 		try {
/******/ 			var request = new XMLHttpRequest();
/******/ 			var requestPath = __webpack_require__.p + "" + hotCurrentHash + ".hot-update.json";
/******/ 			request.open("GET", requestPath, true);
/******/ 			request.timeout = 10000;
/******/ 			request.send(null);
/******/ 		} catch(err) {
/******/ 			return callback(err);
/******/ 		}
/******/ 		request.onreadystatechange = function() {
/******/ 			if(request.readyState !== 4) return;
/******/ 			if(request.status === 0) {
/******/ 				// timeout
/******/ 				callback(new Error("Manifest request to " + requestPath + " timed out."));
/******/ 			} else if(request.status === 404) {
/******/ 				// no update available
/******/ 				callback();
/******/ 			} else if(request.status !== 200 && request.status !== 304) {
/******/ 				// other failure
/******/ 				callback(new Error("Manifest request to " + requestPath + " failed."));
/******/ 			} else {
/******/ 				// success
/******/ 				try {
/******/ 					var update = JSON.parse(request.responseText);
/******/ 				} catch(e) {
/******/ 					callback(e);
/******/ 					return;
/******/ 				}
/******/ 				callback(null, update);
/******/ 			}
/******/ 		};
/******/ 	}
/******/
/******/ 	
/******/ 	
/******/ 	// Copied from https://github.com/facebook/react/blob/bef45b0/src/shared/utils/canDefineProperty.js
/******/ 	var canDefineProperty = false;
/******/ 	try {
/******/ 		Object.defineProperty({}, "x", {
/******/ 			get: function() {}
/******/ 		});
/******/ 		canDefineProperty = true;
/******/ 	} catch(x) {
/******/ 		// IE will fail on defineProperty
/******/ 	}
/******/ 	
/******/ 	var hotApplyOnUpdate = true;
/******/ 	var hotCurrentHash = "58a94b76d159066ace1d"; // eslint-disable-line no-unused-vars
/******/ 	var hotCurrentModuleData = {};
/******/ 	var hotCurrentParents = []; // eslint-disable-line no-unused-vars
/******/ 	
/******/ 	function hotCreateRequire(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var me = installedModules[moduleId];
/******/ 		if(!me) return __webpack_require__;
/******/ 		var fn = function(request) {
/******/ 			if(me.hot.active) {
/******/ 				if(installedModules[request]) {
/******/ 					if(installedModules[request].parents.indexOf(moduleId) < 0)
/******/ 						installedModules[request].parents.push(moduleId);
/******/ 					if(me.children.indexOf(request) < 0)
/******/ 						me.children.push(request);
/******/ 				} else hotCurrentParents = [moduleId];
/******/ 			} else {
/******/ 				console.warn("[HMR] unexpected require(" + request + ") from disposed module " + moduleId);
/******/ 				hotCurrentParents = [];
/******/ 			}
/******/ 			return __webpack_require__(request);
/******/ 		};
/******/ 		for(var name in __webpack_require__) {
/******/ 			if(Object.prototype.hasOwnProperty.call(__webpack_require__, name)) {
/******/ 				if(canDefineProperty) {
/******/ 					Object.defineProperty(fn, name, (function(name) {
/******/ 						return {
/******/ 							configurable: true,
/******/ 							enumerable: true,
/******/ 							get: function() {
/******/ 								return __webpack_require__[name];
/******/ 							},
/******/ 							set: function(value) {
/******/ 								__webpack_require__[name] = value;
/******/ 							}
/******/ 						};
/******/ 					}(name)));
/******/ 				} else {
/******/ 					fn[name] = __webpack_require__[name];
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		function ensure(chunkId, callback) {
/******/ 			if(hotStatus === "ready")
/******/ 				hotSetStatus("prepare");
/******/ 			hotChunksLoading++;
/******/ 			__webpack_require__.e(chunkId, function() {
/******/ 				try {
/******/ 					callback.call(null, fn);
/******/ 				} finally {
/******/ 					finishChunkLoading();
/******/ 				}
/******/ 	
/******/ 				function finishChunkLoading() {
/******/ 					hotChunksLoading--;
/******/ 					if(hotStatus === "prepare") {
/******/ 						if(!hotWaitingFilesMap[chunkId]) {
/******/ 							hotEnsureUpdateChunk(chunkId);
/******/ 						}
/******/ 						if(hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 							hotUpdateDownloaded();
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 			});
/******/ 		}
/******/ 		if(canDefineProperty) {
/******/ 			Object.defineProperty(fn, "e", {
/******/ 				enumerable: true,
/******/ 				value: ensure
/******/ 			});
/******/ 		} else {
/******/ 			fn.e = ensure;
/******/ 		}
/******/ 		return fn;
/******/ 	}
/******/ 	
/******/ 	function hotCreateModule(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var hot = {
/******/ 			// private stuff
/******/ 			_acceptedDependencies: {},
/******/ 			_declinedDependencies: {},
/******/ 			_selfAccepted: false,
/******/ 			_selfDeclined: false,
/******/ 			_disposeHandlers: [],
/******/ 	
/******/ 			// Module API
/******/ 			active: true,
/******/ 			accept: function(dep, callback) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfAccepted = true;
/******/ 				else if(typeof dep === "function")
/******/ 					hot._selfAccepted = dep;
/******/ 				else if(typeof dep === "object")
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._acceptedDependencies[dep[i]] = callback;
/******/ 				else
/******/ 					hot._acceptedDependencies[dep] = callback;
/******/ 			},
/******/ 			decline: function(dep) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfDeclined = true;
/******/ 				else if(typeof dep === "number")
/******/ 					hot._declinedDependencies[dep] = true;
/******/ 				else
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._declinedDependencies[dep[i]] = true;
/******/ 			},
/******/ 			dispose: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			addDisposeHandler: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			removeDisposeHandler: function(callback) {
/******/ 				var idx = hot._disposeHandlers.indexOf(callback);
/******/ 				if(idx >= 0) hot._disposeHandlers.splice(idx, 1);
/******/ 			},
/******/ 	
/******/ 			// Management API
/******/ 			check: hotCheck,
/******/ 			apply: hotApply,
/******/ 			status: function(l) {
/******/ 				if(!l) return hotStatus;
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			addStatusHandler: function(l) {
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			removeStatusHandler: function(l) {
/******/ 				var idx = hotStatusHandlers.indexOf(l);
/******/ 				if(idx >= 0) hotStatusHandlers.splice(idx, 1);
/******/ 			},
/******/ 	
/******/ 			//inherit from previous dispose call
/******/ 			data: hotCurrentModuleData[moduleId]
/******/ 		};
/******/ 		return hot;
/******/ 	}
/******/ 	
/******/ 	var hotStatusHandlers = [];
/******/ 	var hotStatus = "idle";
/******/ 	
/******/ 	function hotSetStatus(newStatus) {
/******/ 		hotStatus = newStatus;
/******/ 		for(var i = 0; i < hotStatusHandlers.length; i++)
/******/ 			hotStatusHandlers[i].call(null, newStatus);
/******/ 	}
/******/ 	
/******/ 	// while downloading
/******/ 	var hotWaitingFiles = 0;
/******/ 	var hotChunksLoading = 0;
/******/ 	var hotWaitingFilesMap = {};
/******/ 	var hotRequestedFilesMap = {};
/******/ 	var hotAvailibleFilesMap = {};
/******/ 	var hotCallback;
/******/ 	
/******/ 	// The update info
/******/ 	var hotUpdate, hotUpdateNewHash;
/******/ 	
/******/ 	function toModuleId(id) {
/******/ 		var isNumber = (+id) + "" === id;
/******/ 		return isNumber ? +id : id;
/******/ 	}
/******/ 	
/******/ 	function hotCheck(apply, callback) {
/******/ 		if(hotStatus !== "idle") throw new Error("check() is only allowed in idle status");
/******/ 		if(typeof apply === "function") {
/******/ 			hotApplyOnUpdate = false;
/******/ 			callback = apply;
/******/ 		} else {
/******/ 			hotApplyOnUpdate = apply;
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		}
/******/ 		hotSetStatus("check");
/******/ 		hotDownloadManifest(function(err, update) {
/******/ 			if(err) return callback(err);
/******/ 			if(!update) {
/******/ 				hotSetStatus("idle");
/******/ 				callback(null, null);
/******/ 				return;
/******/ 			}
/******/ 	
/******/ 			hotRequestedFilesMap = {};
/******/ 			hotAvailibleFilesMap = {};
/******/ 			hotWaitingFilesMap = {};
/******/ 			for(var i = 0; i < update.c.length; i++)
/******/ 				hotAvailibleFilesMap[update.c[i]] = true;
/******/ 			hotUpdateNewHash = update.h;
/******/ 	
/******/ 			hotSetStatus("prepare");
/******/ 			hotCallback = callback;
/******/ 			hotUpdate = {};
/******/ 			for(var chunkId in installedChunks)
/******/ 			{ // eslint-disable-line no-lone-blocks
/******/ 				/*globals chunkId */
/******/ 				hotEnsureUpdateChunk(chunkId);
/******/ 			}
/******/ 			if(hotStatus === "prepare" && hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 				hotUpdateDownloaded();
/******/ 			}
/******/ 		});
/******/ 	}
/******/ 	
/******/ 	function hotAddUpdateChunk(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		if(!hotAvailibleFilesMap[chunkId] || !hotRequestedFilesMap[chunkId])
/******/ 			return;
/******/ 		hotRequestedFilesMap[chunkId] = false;
/******/ 		for(var moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				hotUpdate[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(--hotWaitingFiles === 0 && hotChunksLoading === 0) {
/******/ 			hotUpdateDownloaded();
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotEnsureUpdateChunk(chunkId) {
/******/ 		if(!hotAvailibleFilesMap[chunkId]) {
/******/ 			hotWaitingFilesMap[chunkId] = true;
/******/ 		} else {
/******/ 			hotRequestedFilesMap[chunkId] = true;
/******/ 			hotWaitingFiles++;
/******/ 			hotDownloadUpdateChunk(chunkId);
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotUpdateDownloaded() {
/******/ 		hotSetStatus("ready");
/******/ 		var callback = hotCallback;
/******/ 		hotCallback = null;
/******/ 		if(!callback) return;
/******/ 		if(hotApplyOnUpdate) {
/******/ 			hotApply(hotApplyOnUpdate, callback);
/******/ 		} else {
/******/ 			var outdatedModules = [];
/******/ 			for(var id in hotUpdate) {
/******/ 				if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 					outdatedModules.push(toModuleId(id));
/******/ 				}
/******/ 			}
/******/ 			callback(null, outdatedModules);
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotApply(options, callback) {
/******/ 		if(hotStatus !== "ready") throw new Error("apply() is only allowed in ready status");
/******/ 		if(typeof options === "function") {
/******/ 			callback = options;
/******/ 			options = {};
/******/ 		} else if(options && typeof options === "object") {
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		} else {
/******/ 			options = {};
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		}
/******/ 	
/******/ 		function getAffectedStuff(module) {
/******/ 			var outdatedModules = [module];
/******/ 			var outdatedDependencies = {};
/******/ 	
/******/ 			var queue = outdatedModules.slice();
/******/ 			while(queue.length > 0) {
/******/ 				var moduleId = queue.pop();
/******/ 				var module = installedModules[moduleId];
/******/ 				if(!module || module.hot._selfAccepted)
/******/ 					continue;
/******/ 				if(module.hot._selfDeclined) {
/******/ 					return new Error("Aborted because of self decline: " + moduleId);
/******/ 				}
/******/ 				if(moduleId === 0) {
/******/ 					return;
/******/ 				}
/******/ 				for(var i = 0; i < module.parents.length; i++) {
/******/ 					var parentId = module.parents[i];
/******/ 					var parent = installedModules[parentId];
/******/ 					if(parent.hot._declinedDependencies[moduleId]) {
/******/ 						return new Error("Aborted because of declined dependency: " + moduleId + " in " + parentId);
/******/ 					}
/******/ 					if(outdatedModules.indexOf(parentId) >= 0) continue;
/******/ 					if(parent.hot._acceptedDependencies[moduleId]) {
/******/ 						if(!outdatedDependencies[parentId])
/******/ 							outdatedDependencies[parentId] = [];
/******/ 						addAllToSet(outdatedDependencies[parentId], [moduleId]);
/******/ 						continue;
/******/ 					}
/******/ 					delete outdatedDependencies[parentId];
/******/ 					outdatedModules.push(parentId);
/******/ 					queue.push(parentId);
/******/ 				}
/******/ 			}
/******/ 	
/******/ 			return [outdatedModules, outdatedDependencies];
/******/ 		}
/******/ 	
/******/ 		function addAllToSet(a, b) {
/******/ 			for(var i = 0; i < b.length; i++) {
/******/ 				var item = b[i];
/******/ 				if(a.indexOf(item) < 0)
/******/ 					a.push(item);
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// at begin all updates modules are outdated
/******/ 		// the "outdated" status can propagate to parents if they don't accept the children
/******/ 		var outdatedDependencies = {};
/******/ 		var outdatedModules = [];
/******/ 		var appliedUpdate = {};
/******/ 		for(var id in hotUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 				var moduleId = toModuleId(id);
/******/ 				var result = getAffectedStuff(moduleId);
/******/ 				if(!result) {
/******/ 					if(options.ignoreUnaccepted)
/******/ 						continue;
/******/ 					hotSetStatus("abort");
/******/ 					return callback(new Error("Aborted because " + moduleId + " is not accepted"));
/******/ 				}
/******/ 				if(result instanceof Error) {
/******/ 					hotSetStatus("abort");
/******/ 					return callback(result);
/******/ 				}
/******/ 				appliedUpdate[moduleId] = hotUpdate[moduleId];
/******/ 				addAllToSet(outdatedModules, result[0]);
/******/ 				for(var moduleId in result[1]) {
/******/ 					if(Object.prototype.hasOwnProperty.call(result[1], moduleId)) {
/******/ 						if(!outdatedDependencies[moduleId])
/******/ 							outdatedDependencies[moduleId] = [];
/******/ 						addAllToSet(outdatedDependencies[moduleId], result[1][moduleId]);
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Store self accepted outdated modules to require them later by the module system
/******/ 		var outdatedSelfAcceptedModules = [];
/******/ 		for(var i = 0; i < outdatedModules.length; i++) {
/******/ 			var moduleId = outdatedModules[i];
/******/ 			if(installedModules[moduleId] && installedModules[moduleId].hot._selfAccepted)
/******/ 				outdatedSelfAcceptedModules.push({
/******/ 					module: moduleId,
/******/ 					errorHandler: installedModules[moduleId].hot._selfAccepted
/******/ 				});
/******/ 		}
/******/ 	
/******/ 		// Now in "dispose" phase
/******/ 		hotSetStatus("dispose");
/******/ 		var queue = outdatedModules.slice();
/******/ 		while(queue.length > 0) {
/******/ 			var moduleId = queue.pop();
/******/ 			var module = installedModules[moduleId];
/******/ 			if(!module) continue;
/******/ 	
/******/ 			var data = {};
/******/ 	
/******/ 			// Call dispose handlers
/******/ 			var disposeHandlers = module.hot._disposeHandlers;
/******/ 			for(var j = 0; j < disposeHandlers.length; j++) {
/******/ 				var cb = disposeHandlers[j];
/******/ 				cb(data);
/******/ 			}
/******/ 			hotCurrentModuleData[moduleId] = data;
/******/ 	
/******/ 			// disable module (this disables requires from this module)
/******/ 			module.hot.active = false;
/******/ 	
/******/ 			// remove module from cache
/******/ 			delete installedModules[moduleId];
/******/ 	
/******/ 			// remove "parents" references from all children
/******/ 			for(var j = 0; j < module.children.length; j++) {
/******/ 				var child = installedModules[module.children[j]];
/******/ 				if(!child) continue;
/******/ 				var idx = child.parents.indexOf(moduleId);
/******/ 				if(idx >= 0) {
/******/ 					child.parents.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// remove outdated dependency from module children
/******/ 		for(var moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				var module = installedModules[moduleId];
/******/ 				var moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 				for(var j = 0; j < moduleOutdatedDependencies.length; j++) {
/******/ 					var dependency = moduleOutdatedDependencies[j];
/******/ 					var idx = module.children.indexOf(dependency);
/******/ 					if(idx >= 0) module.children.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Not in "apply" phase
/******/ 		hotSetStatus("apply");
/******/ 	
/******/ 		hotCurrentHash = hotUpdateNewHash;
/******/ 	
/******/ 		// insert new code
/******/ 		for(var moduleId in appliedUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(appliedUpdate, moduleId)) {
/******/ 				modules[moduleId] = appliedUpdate[moduleId];
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// call accept handlers
/******/ 		var error = null;
/******/ 		for(var moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				var module = installedModules[moduleId];
/******/ 				var moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 				var callbacks = [];
/******/ 				for(var i = 0; i < moduleOutdatedDependencies.length; i++) {
/******/ 					var dependency = moduleOutdatedDependencies[i];
/******/ 					var cb = module.hot._acceptedDependencies[dependency];
/******/ 					if(callbacks.indexOf(cb) >= 0) continue;
/******/ 					callbacks.push(cb);
/******/ 				}
/******/ 				for(var i = 0; i < callbacks.length; i++) {
/******/ 					var cb = callbacks[i];
/******/ 					try {
/******/ 						cb(outdatedDependencies);
/******/ 					} catch(err) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Load self accepted modules
/******/ 		for(var i = 0; i < outdatedSelfAcceptedModules.length; i++) {
/******/ 			var item = outdatedSelfAcceptedModules[i];
/******/ 			var moduleId = item.module;
/******/ 			hotCurrentParents = [moduleId];
/******/ 			try {
/******/ 				__webpack_require__(moduleId);
/******/ 			} catch(err) {
/******/ 				if(typeof item.errorHandler === "function") {
/******/ 					try {
/******/ 						item.errorHandler(err);
/******/ 					} catch(err) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				} else if(!error)
/******/ 					error = err;
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// handle errors in accept handlers and self accepted module load
/******/ 		if(error) {
/******/ 			hotSetStatus("fail");
/******/ 			return callback(error);
/******/ 		}
/******/ 	
/******/ 		hotSetStatus("idle");
/******/ 		callback(null, outdatedModules);
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			hot: hotCreateModule(moduleId),
/******/ 			parents: hotCurrentParents,
/******/ 			children: []
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, hotCreateRequire(moduleId));
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "app/newIndex/assets/bundle-" + {"1":"fee89"}[chunkId] + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// __webpack_hash__
/******/ 	__webpack_require__.h = function() { return hotCurrentHash; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return hotCreateRequire(0)(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(2);


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

	;
	(function ($) {
		$.fn.picLazyLoad = function (settings) {
			var $this = $(this),
				_winScrollTop = 0,
				_winHeight = $(window).height();
			settings = $.extend({
				threshold: 0,
				placeholder: '/images/common_course_bigblank@2x.png'
			}, settings || {});
			lazyLoadPic();
			$(window).on('scroll', function () {
				_winScrollTop = document.body.scrollTop;
				lazyLoadPic();
			});
	
			function lazyLoadPic() {
				$this.each(function () {
					var $self = $(this);
					if ($self.is('img')) {
						if ($self.attr('data-original')) {
							var _offsetTop = $self.offset().top;
							if ((_offsetTop - settings.threshold) <= (_winHeight + _winScrollTop)) {
								$self.attr('src', $self.attr('data-original'));
								$self.removeAttr('data-original');
							}
						}
					}
					else {
						if ($self.attr('data-original')) {
							if ($self.css('background-image') == 'none') {
								$self.css('background-image', 'url(' + settings.placeholder + ')');
							}
							var _offsetTop = $self.offset().top;
							if ((_offsetTop - settings.threshold) <= (_winHeight + _winScrollTop)) {
								$self.css('background-image', 'url(' + $self.attr('data-original') + ')');
								$self.removeAttr('data-original');
							}
						}
					}
				});
			}
		}
	})(Zepto);

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	//require('./js/base.js');
	__webpack_require__(3);
	__webpack_require__(38);
	__webpack_require__(39);
	// var isNew = require('./js/abtest.js');
	//var dot = require('dot');
	var Utils = function () {
	    var self = this;
	    this.get_testDate = function () { //#testdate=2016/1/9T00:00:00
	        var search = location.hash;
	        search = search.substr(1, search.length - 1);
	        var search_array = search.split('&');
	        var search_obj = {};
	        for (var i = 0; i < search_array.length; i++) {
	            var _s = search_array[i].split('=');
	            search_obj[_s[0]] = _s[1];
	        }
	        return new Date(search_obj.testdate && search_obj.testdate.replace(/[a-z]/ig, ' ')).getTime();
	    };
	
	    this.serverTime = function () {
	        var server_time = $(window.hdDateTime).val();
	        //format
	        server_time = server_time.replace(/\-/ig, '/').replace(/T/, ' ').split('.')[0];
	        server_time = this.get_testDate() ? this.get_testDate() : new Date(server_time).getTime();
	        return server_time;
	    };
	
	    this.getCurrItem = function (list) {
	        return list.filter(function (v) {
	            var isFiltered = self.serverTime() >= new Date(v.start).getTime() && self.serverTime() < new Date(v.end).getTime();
	            return isFiltered;
	        })[0];
	    };
	};
	$(function () {
	    //slide
	    // setTimeout(function () {
	        TouchSlide({
	            slideCell: "#slideBox",
	            titCell: ".hd ul", //开启自动分页 autoPage:true ，此时设置 titCell 为导航元素包裹层
	            mainCell: ".bd ul",
	            effect: "leftLoop",
	            autoPage: true, //自动分页
	            autoPlay: true, //自动播放
	            interTime: 5000,
	            startFun: function (i, c) {
	                var ad_num = 525, //第一张a6;
	                    html = '',
	                    $curLi = $("#slideBox li").eq(i + 2);
	
	                if (!$curLi.children().length) {
	                    i == 0 && (ad_num = 526); //第二张a6;
	                    i == 1 && (ad_num = 527); //第三张a6;
	
	                    if (i == 0 || i == 1) {
	                        html = "" + "<div id='a6_adspace_" + ad_num + "'></div>" + "<script type='text/javascript'>" + "a6adspace = document.createElement('script'); " + "a6adspace.type = 'text/javascript';" + " a6adspace.src = 'https://a6.hujiang.com/v2/a.ashx?aid=" + ad_num + "';" + " document.getElementById('a6_adspace_" + ad_num + "').appendChild(a6adspace);" + "<\/script>";
	                        $curLi.append(html);
	                    }
	                }
	
	            }
	        });
	    // }, 2000);
	
	    //APP引流
	    $('head').append('<meta name="apple-itunes-app" content="app-id=738227542, app-argument=hujiangclass3://hjclass.hujiang.com/myclasslist" >');
	
	
	    (function () {
	        var utils = new Utils();
	        var timeList = [{
	            start: '2016/8/22 13:00:00',
	            end: '2016/9/2 00:00:00'
	        }];
	        var currentItem = utils.getCurrItem(timeList);
	        var render = new Render();
	        if (currentItem) {
	            __webpack_require__.e/* nsure */(1, function (require) {
	                var isNew = __webpack_require__(43);
	                if (isNew && isNew.isNew) {
	                    render.init();
	                }
	            })
	        } else {
	            render.init();
	        }
	    })()
	
	
	
	    // 图片懒加载
	    $('body').find('img').picLazyLoad({
	        threshold: 100
	    });
	
	    var slideText = new SlideText();
	    slideText.init();
	
	})
	
	//文字广告轮播
	var SlideText = function () {
	    this.mod = $('.slideText');
	}
	SlideText.prototype = {
	    init: function () {
	        this.slide();
	    },
	    slide: function () {
	        var timer = 2000;
	        var num = 0;
	        var list = this.mod.find('.list');
	        var transtion = 0.3;
	        //        var item = list.find('>a');
	        if (list.find('a').length > 1) {
	            list.append(list.find('a').eq(0).clone());
	
	            var len = list.find('a').length;
	
	            setTimeout(function () {
	                num = num + 1;
	                num = num >= len ? 0 : num;
	                move = -2 * num + 'rem';
	
	                list.css({
	                    '-webkit-transform': 'translate3d(0,' + move + ',0)'
	                });
	                if (num == 0) {
	                    timer = 0;
	                    transtion = 0;
	                } else {
	                    timer = 2000;
	                    transtion = 0.3;
	                }
	                list.css({
	                    '-webkit-transition': transtion + 's'
	                });
	
	                setTimeout(arguments.callee, timer)
	            }, timer)
	        }
	    }
	}
	
	
	var Render = function () {
	    //    this.isloaded = false;
	    this.preloadHeight = 1000;
	};
	Render.prototype = {
	    init: function () {
	        this.scroll();
	        this.loopload();
	        this.initFloorNav();
	        //开学动画弹窗
	        this.initAlertAnimation();
	        //开学动画弹窗
	        this.flowStudy();//528活动弹框
	    },
	    getRecommendInfo: function (arg, callback) {
	        var me = this;
	        $.ajax({
	            type: "get",
	            url: "/handler/smart_recommend.ashx",
	            async: true,
	            success: function (data) {
	                //                if (data.isSuccess) {
	                var data = JSON.parse(data).data;
	                callback && callback(arg, data);
	                //                }
	
	            }
	        })
	    },
	    getCateInfo: function (cate, arg, callback, con) {
	        var me = this;
	        $.ajax({
	            type: "get",
	            url: "/handler/RecomCateClass.ashx",
	            data: {
	                cate: cate,
	                topNum: 20
	            },
	            async: true,
	            success: function (data) {
	                var data = JSON.parse(data).Data;
	                callback && callback.call(me, arg, data, con);
	            }
	        })
	    },
	    getdot: function () {
	        return __webpack_require__(40);
	    },
	    renderRecommendTemplate: function (obj, jsons) {
	        var tmpMaybeLike = $('#tmp-maybeLike').html();
	        $('#con-maybeLike').append(obj.template(tmpMaybeLike)(jsons))
	    },
	    renderCateTemplate: function (obj, jsons, con) {
	        var tmpCate = $('#tmp-recommend').html();
	        con.append(obj.template(tmpCate)(jsons));
	        this.resetWidth(con);
	        this.lazyload(con);
	    },
	    scroll: function () {
	        var me = this;
	        var maybeLike = $('#con-maybeLike');
	        $(window).on('scroll', function () {
	            if (maybeLike.data('isloaded') == 'false') {
	                var scrollTop = window.scrollY;
	
	                var offsetT = maybeLike.offset().top;
	                if (scrollTop > offsetT - $(window).height() - me.preloadHeight) {
	                    maybeLike.data('isloaded', true);
	                    me.getRecommendInfo(me.getdot(), me.renderRecommendTemplate);
	                }
	            }
	        })
	    },
	    loopload: function () {
	        var me = this;
	        var recommendCon = $('.con-recommend');
	
	        $(window).on('scroll', function () {
	            var scrollTop = window.scrollY;
	            $.each(recommendCon, function (i, e) {
	
	                if ($(e).data('isloaded') == 'false') {
	                    var cate = $(e).data('cate');
	                    var offsetT = $(e).offset().top;
	                    if (scrollTop > offsetT - $(window).height() - me.preloadHeight) {
	                        $(e).data('isloaded', 'true');
	                        me.getCateInfo(cate, me.getdot(), me.renderCateTemplate, $(e))
	
	                    }
	                }
	
	            })
	        })
	    },
	    resetWidth: function (con) {
	        var num_lens = con.find('.inlineBox').length;
	        var num_width = con.find('.inlineBox').eq(0).width();
	        var num_pl = parseFloat(con.find('.inlineBox').eq(0).css('padding-left'));
	        con.width(num_lens * num_width + num_pl);
	    },
	    lazyload: function (con) {
	        var initImg = con.find('img');
	        $.each(initImg, function (i, e) {
	            var src = $(e).data('src');
	            if ($(e).offset().left < $(window).width() && $(e).data('src')) {
	                $(e).attr('src', src);
	                $(e).data('src', '');
	            }
	        })
	
	
	        $('.recommend').scroll(function () {
	            var img = $(this).find('img');
	            //            var scrollL = $(this).scrollLeft();
	            var scrollL = Math.abs($(this).find('.scroll').offset().left);
	            $.each(img, function (i, e) {
	                if (scrollL + $(window).width() >= $(e).offset().left && $(e).data('src')) {
	                    var src = $(e).data('src');
	                    $(e).attr('src', src);
	                    $(e).data('src', '');
	                }
	            })
	
	        })
	    },
	    initFloorNav: function () {
	
	        var $floorNav = $("#courseFloorNav"),
	            $floorCont = $("#floorCont"),
	            floorLefts = [],
	            floorNavWidth = 15,
	            isShowNav = false;
	
	        window.onscroll = function () {
	
	            if (document.body.scrollTop > $("#english").offset().top - 90) {
	                !isShowNav && $floorNav.show();
	                isShowNav = true;
	
	                !floorLefts.length && (function () {
	
	                    for (var k = 0; k < $(".floor-nav").length; k++) {
	                        floorLefts.push($(".floor-nav").eq(k).offset().left);
	                        floorNavWidth += $(".floor-nav").eq(k).width();
	                    }
	                    $floorCont.css({ "width": floorNavWidth });
	
	                })();
	
	            } else {
	                isShowNav && $floorNav.hide();
	                isShowNav = false;
	            }
	
	            for (var i = 0; i < $(".floor-item").length; i++) {
	
	                if (document.body.scrollTop > $(".floor-item").eq(i).offset().top - 90) {
	                    document.getElementById("courseFloorNav").scrollLeft = floorLefts[i];
	                    $(".floor-nav").removeClass("on");
	                    $(".floor-nav").eq(i).addClass("on");
	                }
	            };
	
	        };
	        //点击浮层菜单，到特定的菜单课程
	        $floorNav.on("click", "a", function () {
	            var floorId = $(this).attr("data-floor"),
	                fixedHeight = $(".limit_length").height() + $("#courseFloorNav").height();
	            document.body.scrollTop = $("#" + floorId).offset().top - fixedHeight;
	            // $(".floor-nav").removeClass("on");
	            // $(this).addClass("on");
	        });
	
	
	    },
	    initAlertAnimation: function () {
	        var host = window.location.host;
				var url = '//' + host + '/homeapi/v1/homepage/mcimagelink';
	             var imgBox='<div id="mcpop">\
	                <div class="meng"></div>\
	                <div class="mcimgbox">\
	                    <i class="mc-cha"></i>\
	                    <a style="display: inline-block;" href="{hrefInfo}">\
	                        <img src="{imgsrc}" alt="" class="mc-currentimg" />\
	                    </a>\
	                </div>\
				 </div>';
				//var data={"id":100,"terminalType":1,"displayType":"1","linkUrl":"www.baidu.com","imageUrl":"http://120.26.218.42/img/testmc1.jpg","imageWidth":"247","imageHeight":"238","startTime":"2017-07-11T00:00:00","endTime":"2017-07-29T00:00:00"};
				$.getJSON(url,function(res){
					if(res.status===0 && res.data.id){
						var data=res.data,homePopupInfo=null;
						if(data != null && (data && data.id)){//存在弹窗数据
							homePopupInfo={
								primaryId:data.id,
								imageUrl:data.imageUrl,
								linkUrl:data.linkUrl,
								imageWidth:parseFloat(data.imageWidth),
								imageHeight:parseFloat(data.imageHeight)
							};
						}
	                    var cookieKey = 'mchomepop';
						var setCookie=function(name, value, expires, path, domain, secure) {
							var expires_date = new Date((new Date()).getTime() + (expires));
							document.cookie = name + '=' + escape(value) + ((expires) ? ';expires=' + expires_date.toGMTString() : '') + ((path) ? ';path=' + path : '') + ((domain) ? ';domain=' + domain : '') + ((secure) ? ';secure' : '');
	                    };
	                    var getCookie = function (key) {
	                        var mat = new RegExp('(^|[^a-z])' + key + '=(.*?)(;|$)', 'i').exec(document.cookie);
	                        return mat ? decodeURIComponent(mat[2]) : '';
	                    };
	                    var popIds = getCookie(cookieKey);
	
						var isShowPopup=function(){
							return homePopupInfo && popIds.indexOf(homePopupInfo.primaryId+'') == -1;
						};
						if(isShowPopup()){
							var imgInfo=imgBox.replace(/{hrefInfo}/gim,data.linkUrl).replace(/{imgsrc}/gim,data.imageUrl);
							$('body').append(imgInfo);
						}
						$("#mcpop .mc-cha").on("click",function(){
	                        var cookie_date=31536000000;
							setCookie(cookieKey,JSON.stringify(homePopupInfo.primaryId),cookie_date,"/");//更新时间
							popupToggle(0);
						});
					}
				});
				function popupToggle(params){
					var cssParams={"display":"block"};
					if(params==0){
						cssParams={"display":"none"};
					}
					$("#mcpop").css(cssParams);
				}
	
	    },
	    flowStudy: function () {
	        //528 弹窗
	        var timeList = [ {
	            start: '2017/7/01 00:00:00',
	            end: '2017/7/20 00:00:00',
	            call: fun,
	            day: 99
	        }, {
	            start: '2017/7/20 00:00:00',
	            end: '2017/7/22 00:00:00',
	            call: fun,
	            day: 10
	        }, {
	            start: '2017/7/22 00:00:00',
	            end: '2017/7/28 00:00:00',
	            call: fun,
	            day: 99
	        }, {
	            start: '2017/7/28 00:00:00',
	            end: '2017/8/5 00:00:00',
	            call: fun,
	            day: 11
	        }, {
	            start: '2017/8/5 00:00:00',
	            end: '2017/8/16 00:00:00',
	            call: fun,
	            day: 12
	        },{
	            start: '2017/8/16 00:00:00',
	            end: '2017/9/28 00:00:00',
	            call: fun,
	            day: 99
	        }];
	        var audioElementHovertree = document.createElement('audio');
	        var currentItem = {};
	        function runAsync() {
	            var def = $.Deferred();
	            var utils = new Utils();
	            currentItem = $.extend({}, utils.getCurrItem(timeList));
	            def.resolve(currentItem);
	            return def;
	        }
	        runAsync().then(function (currentItem) {
	            // 在活动期间，更换悬浮广告图片和链接
	
	            if (currentItem) {
	                chagePositiAdv();
	                // if (currentItem.day && !Cookies.get('modal_6'+currentItem.day)) {
	                //     var html = $('#new-season-template2').html();
	                //     $('body').append($('<div id="new-528">' + html + '</div>'));
	                //     $('.cha,.quan').on('click', backOff528);
	                //     currentItem.call();
	                // }
	            }
	        })
	        function chagePositiAdv() {
	            e = $('.activity-overlay');
	            if (e.length == 0) {
	                setTimeout(chagePositiAdv, 100);
	            } else {
	                $('.activity-overlay .fixadv-a').attr('href', '//mc.hujiang.com/classtopic/detail/92093?ch_source=icls_home_1_dbxlb');
	                $('.activity-overlay .fixadv-a img').attr('src', '//n1image.hjfile.cn/zhuanti/2017/08/15/8859af022f646d7ef237eec4e4541180.png');
	            }
	        }
	        //常规弹窗
	        function fun() {
	            var day = this.day;
	            $('#new-528').hide();
	            if (!Cookies.get('modal_62' + day)) {                
	                $('#new-528').show();
	                $('.modal-bg').hide();
	                if(day == 10){
	                    $('.new-bg-ten').addClass('new-bg-normal-10').show();                   
	                }else if (day == 11){
	                    $('.new-bg-eleven').addClass('new-bg-normal-11').show();
	                }else if (day == 99){
	                    $('.new-bg-nine').addClass('new-bg-normal-99').show();
	                }else if (day == 12){
	                    $('.new-bg-twelve').addClass('new-bg-normal-12').show();
	                }
	                
	            }
	        }
	        function backOff528(e) {
	            e.stopPropagation();
	            $('#new-528').hide();
	            //常规弹窗只出现一次
	            //if (currentItem.day == 1) {
	            Cookies.set('modal_62' + currentItem.day, 1, {
	                expires: 10,
	                path: '/'
	            });
	            // audioElementHovertree.pause(); // 暂停
	            //}
	            ht.sendCustomEvent('active2017528');
	        }
	        function music() {
	            //音频地址 https://n1audio.hjfile.cn/zhuanti/2017/05/09/37366d417014f84f2e47ab4f45e96ae8.mp3
	            audioElementHovertree.setAttribute('src', 'https://n1audio.hjfile.cn/zhuanti/2017/05/09/37366d417014f84f2e47ab4f45e96ae8.mp3');
	            //audioElementHovertree.setAttribute('autoplay', 'autoplay');
	            audioElementHovertree.setAttribute('loop', 'loop');
	            //打开自动播放 
	            audioElementHovertree.addEventListener("load", function () {
	                audioElementHovertree.play();
	            }, true);
	        }
	        $('body').on('click', '.palybtn', function () { // 点击暂停 
	            $(this).hide();
	            $('.pausebtn').show().css('display', 'block');; //show暂停按钮
	            audioElementHovertree.pause(); // 暂停
	        });
	
	        $('body').on('click', '.pausebtn', function () { // 点击播放 
	            $(this).hide();
	            $('.palybtn').show().css('display', 'block');; //隐藏播放按钮
	            audioElementHovertree.play(); // 播放
	        });
	
	        $('.activity-overlay').on('touchend', '#imgareaClose', function (e) {
	            $(this).parent().remove();
	            ht.sendCustomEvent("xkzx_cp_dbfcclose");
	            //HJMCommon.setLocalStorage('tip_activityOverlay', 1, 1);
	            Cookies.set('tip_activityOverlay', 1, {
	                expires: 300,
	                path: '/'
	            });
	            e.preventDefault();
	            return false;
	        });
	        var serverTime = new Utils().serverTime();
	        var endTime = '2020/6/1 00:00:00';
	
	        if (Cookies.get('tip_activityOverlay') && serverTime >= new Date(endTime).getTime()) {
	            // if (HJMCommon.getLocalStorage('tip_activityOverlay')) {
	            $(".activity-overlay").remove();
	        }
	        $(document).scroll(function () {
	            var scrollTop = document.body.scrollTop;
	            //超过活动时间
	
	            if (!Cookies.get('tip_activityOverlay') && serverTime < new Date(endTime).getTime()) {
	
	                if (scrollTop > 150) {
	                    $(".activity-overlay").show();
	                } else {
	                    $(".activity-overlay").hide();
	                }
	            }
	        });
	
	
	    }
	}


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

	//sendEvent
	// 电梯导航
	
	var floorRecommend = function (con, text) {
	    con.live('click', 'a', function () {
	        var classid = $(this).data('id');
	        ht.sendCustomEvent("homePage_liftButton", { button_name: text, "link": classid });
	    });
	};
	
	var floorAd = function (floor, floorName, num) {
	    if (!floor.hasClass('topic')) {
	        floor.on('click', 'a', function (e) {
	            if (!$(this).find('.title').length) {
	                var alt = $(this).find('img').attr('alt'),
	                    text = $(this).text(),
	                    val = !!alt ? alt : text;
	                //楼层的底部banner 
	                if ($(e.target).attr('width') == '640') {
	                    val = '底部bannner';
	                }
	                ht.sendCustomEvent("homePage_floor" + num, { button_name: floorName + '——' + val });
	            }
	        });
	    }
	};
	
	$(function () {
	
	    //设备切换;
	    $('.device').on('click', 'a', function () {
	        var index = $(this).index(),
	            typeTxt = '';
	
	        switch (index) {
	            case 0:
	                typeTxt = "APP下载";
	                break;
	
	            case 1:
	                typeTxt = "触屏版";
	                break;
	
	            case 2:
	                typeTxt = "电脑版";
	                break;
	        }
	
	        ht.sendCustomEvent("xkzx_cp_dbqh_v1", { type: typeTxt });
	    })
	    //header打点
	
	
	    $('.entry').on('click', 'a', function () {
	        var index = $(this).index(),
	            typeTxt = '';
	
	        switch (index) {
	            case 0:
	                typeTxt = "英语";
	                break;
	
	            case 1:
	                typeTxt = "日语";
	                break;
	
	            case 2:
	                typeTxt = "英语口语";
	                break;
	
	            case 3:
	                typeTxt = "小语种";
	                break;
	
	            case 4:
	                typeTxt = "托福/雅思";
	                break;
	
	            case 5:
	                typeTxt = "职场/兴趣";
	                break;
	
	            case 6:
	                typeTxt = "中小幼";
	                break;
	
	            case 7:
	                typeTxt = "全部分类";
	                break;
	
	        }
	
	        ht.sendCustomEvent("homePage_8icon", { category_name: typeTxt });
	    });
	
	    $('.loadApp').on('click', '.btn', function () {
	        ht.sendCustomEvent("xkzx_cp_yyxz_v1");
	    });
	
	
	
	    $('section.topic').on('click', 'a.inlineBox', function () {
	        var index = $(this).index() + 1;
	
	        // switch (index) {
	        //     case 0:
	        //         typeTxt = "逢考包过";
	        //         break;
	
	        //     case 1:
	        //         typeTxt = "玩转口语";
	        //         break;
	
	        //     case 2:
	        //         typeTxt = "会计入门";
	        //         break;
	
	        //     case 3:
	        //         typeTxt = "内外兼修";
	        //         break;
	
	        // }
	
	        ht.sendCustomEvent("homePage_4recommendations", { index: index });
	    });
	
	    $('.floor-text').on('click', 'a', function () {
	        var index = $(this).index(),
	            typeTxt = '';
	
	        switch (index) {
	            case 0:
	                typeTxt = "沪江微课";
	                break;
	            case 1:
	                typeTxt = "旅游日语";
	                break;
	            case 3:
	                typeTxt = "1v1评测";
	                break;
	            case 4:
	                typeTxt = "沪江微课";
	                break;
	        }
	
	        ht.sendCustomEvent("xkzx_cp_hjrd_v1", { type: typeTxt });
	    });
	
	    floorAd($('.english'), '英语', 1);
	    floorAd($('.japanese'), '日语', 2);
	    floorAd($('.moreclass'), '小语种', 3);
	    floorAd($('.abroad'), '出国留学', 5);
	    floorAd($('.child'), '中小幼', 4);
	    floorAd($('.banking'), '财会金融', 6);
	    floorAd($('.interest'), '职场兴趣', 7);
	    floorAd($('.pubmed'), '考研', 8);
	
	    floorRecommend($('.english .scroll'), '英语');
	    floorRecommend($('.japanese .scroll'), '日语');
	    floorRecommend($('.moreclass .scroll'), '出国留学');
	    floorRecommend($('.abroad .scroll'), '小语种');
	    floorRecommend($('.child .scroll'), '中小幼');
	    floorRecommend($('.banking .scroll'), '财会金融');
	    floorRecommend($('.interest .scroll'), '职场兴趣');
	    floorRecommend($('.pubmed .scroll'), '考研');
	
	    $('.special').on('click', 'a', function () {
	        var text = $(this).find('p').text();
	        ht.sendCustomEvent("xkzx_cp_wyts_v1", { type: text });
	    });
	
	    $('.maybeLike').on('click', 'a', function () {
	        var classid = $(this).data('id');
	        ht.sendCustomEvent("xkzx_cp_kctj_v1", { type: "智能推荐", "link": classid });
	    });
	
	    $('.reglog').on('click', 'a', function () {
	        var index = $(this).index();
	        switch (index) {
	            case 0:
	                ht.sendCustomEvent("xkzx_cp_kctj_v1", { type: "xkzx_cp_yhdl" });
	                break;
	
	            case 1:
	                ht.sendCustomEvent("xkzx_cp_kctj_v1", { type: "xkzx_cp_yhzc" });
	                break;
	        }
	
	    });
	
	    //首页轮播打点
	    $('.tempWrap img').live('click', function () {
	        ht.sendCustomEvent('homePage_banner');
	    })
	
	    //首页底部浮层
	    $('.activity-overlay').on('click', 'a', function () {
	        var link = $(this).attr('href');
	        ht.sendCustomEvent("xkzx_cp_dbfc_v1", { type: link });
	    });
	
	    //A6广告打点,大促banner
	    $("#a6_adspace_661").on('click', function () {
	        ht.sendCustomEvent("homePage_mobileCheer", { type: $(this).attr('id') });
	    });
	
	    //电梯导航打点
	    $("#courseFloorNav a").live("click", function () {
	        ht.sendCustomEvent("homePage_liftButton", { button_name: $(this).text() });
	    });
	
	    //给楼层绑定打点事件
	    for (var i = 0; i < $(".floor-visible").length; i++) {
	        $(window).on('scroll', traceFloor($(".floor-visible").eq(i).attr('id')));
	    }
	
	    function traceFloor(floorId) {
	        var $floor = $("#" + floorId);
	        var bindFunc = function () {
	            var scrollTop = document.body.scrollTop,
	                floorTop = $floor.offset().top,
	                floorHeight = $floor.height(),
	                wHeight = $(window).height();
	
	            if (floorId == "special" && scrollTop > floorTop + floorHeight - wHeight) {
	                ht.sendCustomEvent("xkzx_impression_v1", { type: floorId });
	                $(window).off('scroll', bindFunc);
	                return;
	            }
	
	            if (scrollTop > floorTop - 90 && scrollTop < floorTop + floorHeight - 90) {
	                ht.sendCustomEvent("xkzx_impression_v1", { type: floorId });
	                $(window).off('scroll', bindFunc);
	            }
	        };
	        return bindFunc;
	    }
	    // 阻止默认事件跳转-
	    $('body').on('click', 'a', function (event) {
	        var _href = $(this).attr('href');
	        var _targ = $(this).attr('target');
	        // 存在href && 不存在 target && href是有效的链接-
	        if (_href && !_targ && !/^(#|java)/i.test(_href)) {
	            setTimeout(function () {
	                location.href = _href;
	            }, 200);
	            event.preventDefault();
	        }
	    });
	})


/***/ }),

/***/ 39:
/***/ (function(module, exports) {

	(function () {
	
	    var ua = navigator.userAgent,
	        isIOS = /iphone|ipad|ipod/i.test(ua),
	        isAndroid = /android/i.test(ua),
	        isChrome = /chrome|crios/i.test(ua),
	        isWeixin = /micromessenger/i.test(ua);
	
	    var appPopup = {
	        hasAppCookieName: "has_hjclass_app",
	
	        attachAppPopup: function () {
	            var alink = $("#video a.video_content")[0], me = this;
	            if (!alink) return;
	            me.__oldOnclick = alink.onclick;
	            alink.onclick = function () {
	                if (me.hasAppInstalled()) {
	                    me.callApp();
	                } else {
	                    me.showAppPopup();
	                }
	                return false;
	            };
	        },
	
	        showAppPopup: function () {
	            var me = this;
	            //不提示
	            if (me.hasAppInstalled()) {
	                me.callApp();
	                return;
	            }
	
	            if ($("#div_app_start").length > 0) {
	                //安装应用
	                $("#btnInstallApp").on("click", function () {
	                    if (isWeixin) {
	                        $("#btnInstallApp").attr("href", 'http://m.hujiang.com/app/hjclass/');
	                    } else {
	                        $("#btnInstallApp").attr("href", me.getAppInstallURL());
	                    }
	
	                    $("#btnInstallApp").on("click", function () {
	                        me.hideAppPopup();
	                    });
	                });
	
	                //已安装过，直接调用原生应用
	                $("#btnHasApp").on("click", function () {
	                    if ($("#cbAppNoTip:checked").val() == "1") {
	                        me.setAppInstalled();
	                    }
	
	                    me.hideAppPopup();
	                    me.callApp();
	                });
	
	                $("#div_app_start").show();
	            }
	        },
	
	        hideAppPopup: function () {
	            $("#div_app_start").hide();
	        },
	
	        callApp: function () {
	            var appURI = this.getAppURI();
	            location.href = appURI;
	        },
	
	        hasAppInstalled: function () {
	            return !!this.getCookie(this.hasAppCookieName);
	        },
	
	        setAppInstalled: function () {
	            this.addCookie(this.hasAppCookieName, 1, 7 * 24);
	        },
	
	        getAppURI: function () {
	            var appProtocol = "hujiangclass3://",
	                userid = parseInt($("#hidden_uid").val()),
	                classid = parseInt($("#hidden_cid").val()),
	                lessonid = parseInt($("#hidden_lid").val());
	            return appProtocol + "hjclass.hujiang.com?userid=" + userid + "&classid=" + classid + "&lessonid=" + lessonid;
	        },
	
	        getAppInstallURL: function () {
	            if (isAndroid) {
	                return "http://app.m.hjfile.cn/android/hujiangclass3_h5.apk";
	            } else if (isIOS) {
	                if (isChrome) {
	                    return "itms-apps://phobos.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=738227542";
	                }
	                return "http://lnk8.cn/I10YJ9";
	            }
	            return "";
	        },
	
	        getCookie: function (objName) {
	            var arrStr = document.cookie.split("; ");
	            for (var i = 0; i < arrStr.length; i++) {
	                var temp = arrStr[i].split("=");
	                if (temp[0] == objName) return unescape(temp[1]);
	            }
	            return null;
	        },
	
	        addCookie: function (objName, objValue, objHours, domain) {
	            var str = objName + "=" + escape(objValue);
	            if (objHours > 0) {
	                var date = new Date();
	                var ms = objHours * 3600 * 1000 * 100;
	                date.setTime(date.getTime() + ms);
	                str += ";expires=" + date.toGMTString();
	                if (domain != null && domain.length > 0) {
	                    str += ";domain=" + domain;
	                }
	            }
	            document.cookie = str + ";path=/";
	        },
	
	        getFlashVersion: function () {
	            var ver;
	            if (navigator.plugins && navigator.mimeTypes.length) {
	                ver = (navigator.plugins['Shockwave Flash'] || 0).description;
	            } else if (window['ActiveXObject']) {
	                try {
	                    ver = new ActiveXObject('ShockwaveFlash.ShockwaveFlash')['GetVariable']('$version');
	                } catch (e) { }
	            }
	            if (ver) return ver.match(/\d+/g).splice(0, 3);
	            return null;
	        }
	    };
	
	    if (isIOS || isAndroid) {
	        appPopup.attachAppPopup();
	    }
	    window.appPopup = appPopup;
	
	})();
	
	$(function () {
	    $("#appCloseBtn").click(function () {
	        $("#downloadApp").hide();
	        HJMCommon.setLocalStorage('tip_downloadApp', 1, 365);
	    });
	    if (HJMCommon.getLocalStorage('tip_downloadApp')) {
	        $("#downloadApp").remove();
	    }
	    //下载应用
	    var ua = navigator.userAgent,
	        isWeixin = /micromessenger/i.test(ua),
	        isIos = /iphone|ipad|ipod/i.test(ua),
	        isAndroid = /android/i.test(ua),
	        device_type = isIos ? 'ios' : (isAndroid ? 'android' : '');
	
	   //  if (isWeixin) {
	   //      $('#link_download').attr('href', 'http://m.hujiang.com/app/hjclass/');
	   //  }
	   //  else {
	   //      $('#link_download').attr('href', appPopup.getAppInstallURL())
				// .attr('target', '_blank');
	   //  }
	   //  if (!device_type) {
	   //      $('#downloadApp').hide();
	   //  }
	    
	    $('#link_download').on('click', function (e) {
	       SendEvent(25, 199, '{"dev_type":"{dev_type}"}'.replace('{dev_type}', device_type));
	    });
	    
	});
	
	


/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	/* doT + auto-compilation of doT templates
	 *
	 * 2012, Laura Doktorova, https://github.com/olado/doT
	 * Licensed under the MIT license
	 *
	 * Compiles .def, .dot, .jst files found under the specified path.
	 * It ignores sub-directories.
	 * Template files can have multiple extensions at the same time.
	 * Files with .def extension can be included in other files via {{#def.name}}
	 * Files with .dot extension are compiled into functions with the same name and
	 * can be accessed as renderer.filename
	 * Files with .jst extension are compiled into .js files. Produced .js file can be
	 * loaded as a commonJS, AMD module, or just installed into a global variable
	 * (default is set to window.render).
	 * All inline defines defined in the .jst file are
	 * compiled into separate functions and are available via _render.filename.definename
	 *
	 * Basic usage:
	 * var dots = require("dot").process({path: "./views"});
	 * dots.mytemplate({foo:"hello world"});
	 *
	 * The above snippet will:
	 * 1. Compile all templates in views folder (.dot, .def, .jst)
	 * 2. Place .js files compiled from .jst templates into the same folder.
	 *    These files can be used with require, i.e. require("./views/mytemplate").
	 * 3. Return an object with functions compiled from .dot templates as its properties.
	 * 4. Render mytemplate template.
	 */
	
	var fs = __webpack_require__(41),
		doT = module.exports = __webpack_require__(42);
	
	doT.process = function(options) {
		//path, destination, global, rendermodule, templateSettings
		return new InstallDots(options).compileAll();
	};
	
	function InstallDots(o) {
		this.__path 		= o.path || "./";
		if (this.__path[this.__path.length-1] !== '/') this.__path += '/';
		this.__destination	= o.destination || this.__path;
		if (this.__destination[this.__destination.length-1] !== '/') this.__destination += '/';
		this.__global		= o.global || "window.render";
		this.__rendermodule	= o.rendermodule || {};
		this.__settings 	= o.templateSettings ? copy(o.templateSettings, copy(doT.templateSettings)) : undefined;
		this.__includes		= {};
	}
	
	InstallDots.prototype.compileToFile = function(path, template, def) {
		def = def || {};
		var modulename = path.substring(path.lastIndexOf("/")+1, path.lastIndexOf("."))
			, defs = copy(this.__includes, copy(def))
			, settings = this.__settings || doT.templateSettings
			, compileoptions = copy(settings)
			, defaultcompiled = doT.template(template, settings, defs)
			, exports = []
			, compiled = ""
			, fn;
	
		for (var property in defs) {
			if (defs[property] !== def[property] && defs[property] !== this.__includes[property]) {
				fn = undefined;
				if (typeof defs[property] === 'string') {
					fn = doT.template(defs[property], settings, defs);
				} else if (typeof defs[property] === 'function') {
					fn = defs[property];
				} else if (defs[property].arg) {
					compileoptions.varname = defs[property].arg;
					fn = doT.template(defs[property].text, compileoptions, defs);
				}
				if (fn) {
					compiled += fn.toString().replace('anonymous', property);
					exports.push(property);
				}
			}
		}
		compiled += defaultcompiled.toString().replace('anonymous', modulename);
		fs.writeFileSync(path, "(function(){" + compiled
			+ "var itself=" + modulename + ", _encodeHTML=(" + doT.encodeHTMLSource.toString() + "(" + (settings.doNotSkipEncoded || '') + "));"
			+ addexports(exports)
			+ "if(typeof module!=='undefined' && module.exports) module.exports=itself;else if(typeof define==='function')define(function(){return itself;});else {"
			+ this.__global + "=" + this.__global + "||{};" + this.__global + "['" + modulename + "']=itself;}}());");
	};
	
	function addexports(exports) {
		var ret = '';
		for (var i=0; i< exports.length; i++) {
			ret += "itself." + exports[i]+ "=" + exports[i]+";";
		}
		return ret;
	}
	
	function copy(o, to) {
		to = to || {};
		for (var property in o) {
			to[property] = o[property];
		}
		return to;
	}
	
	function readdata(path) {
		var data = fs.readFileSync(path);
		if (data) return data.toString();
		console.log("problems with " + path);
	}
	
	InstallDots.prototype.compilePath = function(path) {
		var data = readdata(path);
		if (data) {
			return doT.template(data,
						this.__settings || doT.templateSettings,
						copy(this.__includes));
		}
	};
	
	InstallDots.prototype.compileAll = function() {
		if (doT.log) console.log("Compiling all doT templates...");
	
		var defFolder = this.__path,
			sources = fs.readdirSync(defFolder),
			k, l, name;
	
		for( k = 0, l = sources.length; k < l; k++) {
			name = sources[k];
			if (/\.def(\.dot|\.jst)?$/.test(name)) {
				if (doT.log) console.log("Loaded def " + name);
				this.__includes[name.substring(0, name.indexOf('.'))] = readdata(defFolder + name);
			}
		}
	
		for( k = 0, l = sources.length; k < l; k++) {
			name = sources[k];
			if (/\.dot(\.def|\.jst)?$/.test(name)) {
				if (doT.log) console.log("Compiling " + name + " to function");
				this.__rendermodule[name.substring(0, name.indexOf('.'))] = this.compilePath(defFolder + name);
			}
			if (/\.jst(\.dot|\.def)?$/.test(name)) {
				if (doT.log) console.log("Compiling " + name + " to file");
				this.compileToFile(this.__destination + name.substring(0, name.indexOf('.')) + '.js',
						readdata(defFolder + name));
			}
		}
		return this.__rendermodule;
	};


/***/ }),

/***/ 41:
/***/ (function(module, exports) {

	console.log("I'm `fs` modules");


/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// doT.js
	// 2011-2014, Laura Doktorova, https://github.com/olado/doT
	// Licensed under the MIT license.
	
	(function() {
		"use strict";
	
		var doT = {
			version: "1.1.1",
			templateSettings: {
				evaluate:    /\{\{([\s\S]+?(\}?)+)\}\}/g,
				interpolate: /\{\{=([\s\S]+?)\}\}/g,
				encode:      /\{\{!([\s\S]+?)\}\}/g,
				use:         /\{\{#([\s\S]+?)\}\}/g,
				useParams:   /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,
				define:      /\{\{##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,
				defineParams:/^\s*([\w$]+):([\s\S]+)/,
				conditional: /\{\{\?(\?)?\s*([\s\S]*?)\s*\}\}/g,
				iterate:     /\{\{~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g,
				varname:	"it",
				strip:		true,
				append:		true,
				selfcontained: false,
				doNotSkipEncoded: false
			},
			template: undefined, //fn, compile template
			compile:  undefined, //fn, for express
			log: true
		}, _globals;
	
		doT.encodeHTMLSource = function(doNotSkipEncoded) {
			var encodeHTMLRules = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;", "/": "&#47;" },
				matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
			return function(code) {
				return code ? code.toString().replace(matchHTML, function(m) {return encodeHTMLRules[m] || m;}) : "";
			};
		};
	
		_globals = (function(){ return this || (0,eval)("this"); }());
	
		/* istanbul ignore else */
		if (typeof module !== "undefined" && module.exports) {
			module.exports = doT;
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return doT;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			_globals.doT = doT;
		}
	
		var startend = {
			append: { start: "'+(",      end: ")+'",      startencode: "'+encodeHTML(" },
			split:  { start: "';out+=(", end: ");out+='", startencode: "';out+=encodeHTML(" }
		}, skip = /$^/;
	
		function resolveDefs(c, block, def) {
			return ((typeof block === "string") ? block : block.toString())
			.replace(c.define || skip, function(m, code, assign, value) {
				if (code.indexOf("def.") === 0) {
					code = code.substring(4);
				}
				if (!(code in def)) {
					if (assign === ":") {
						if (c.defineParams) value.replace(c.defineParams, function(m, param, v) {
							def[code] = {arg: param, text: v};
						});
						if (!(code in def)) def[code]= value;
					} else {
						new Function("def", "def['"+code+"']=" + value)(def);
					}
				}
				return "";
			})
			.replace(c.use || skip, function(m, code) {
				if (c.useParams) code = code.replace(c.useParams, function(m, s, d, param) {
					if (def[d] && def[d].arg && param) {
						var rw = (d+":"+param).replace(/'|\\/g, "_");
						def.__exp = def.__exp || {};
						def.__exp[rw] = def[d].text.replace(new RegExp("(^|[^\\w$])" + def[d].arg + "([^\\w$])", "g"), "$1" + param + "$2");
						return s + "def.__exp['"+rw+"']";
					}
				});
				var v = new Function("def", "return " + code)(def);
				return v ? resolveDefs(c, v, def) : v;
			});
		}
	
		function unescape(code) {
			return code.replace(/\\('|\\)/g, "$1").replace(/[\r\t\n]/g, " ");
		}
	
		doT.template = function(tmpl, c, def) {
			c = c || doT.templateSettings;
			var cse = c.append ? startend.append : startend.split, needhtmlencode, sid = 0, indv,
				str  = (c.use || c.define) ? resolveDefs(c, tmpl, def || {}) : tmpl;
	
			str = ("var out='" + (c.strip ? str.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g," ")
						.replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g,""): str)
				.replace(/'|\\/g, "\\$&")
				.replace(c.interpolate || skip, function(m, code) {
					return cse.start + unescape(code) + cse.end;
				})
				.replace(c.encode || skip, function(m, code) {
					needhtmlencode = true;
					return cse.startencode + unescape(code) + cse.end;
				})
				.replace(c.conditional || skip, function(m, elsecase, code) {
					return elsecase ?
						(code ? "';}else if(" + unescape(code) + "){out+='" : "';}else{out+='") :
						(code ? "';if(" + unescape(code) + "){out+='" : "';}out+='");
				})
				.replace(c.iterate || skip, function(m, iterate, vname, iname) {
					if (!iterate) return "';} } out+='";
					sid+=1; indv=iname || "i"+sid; iterate=unescape(iterate);
					return "';var arr"+sid+"="+iterate+";if(arr"+sid+"){var "+vname+","+indv+"=-1,l"+sid+"=arr"+sid+".length-1;while("+indv+"<l"+sid+"){"
						+vname+"=arr"+sid+"["+indv+"+=1];out+='";
				})
				.replace(c.evaluate || skip, function(m, code) {
					return "';" + unescape(code) + "out+='";
				})
				+ "';return out;")
				.replace(/\n/g, "\\n").replace(/\t/g, '\\t').replace(/\r/g, "\\r")
				.replace(/(\s|;|\}|^|\{)out\+='';/g, '$1').replace(/\+''/g, "");
				//.replace(/(\s|;|\}|^|\{)out\+=''\+/g,'$1out+=');
	
			if (needhtmlencode) {
				if (!c.selfcontained && _globals && !_globals._encodeHTML) _globals._encodeHTML = doT.encodeHTMLSource(c.doNotSkipEncoded);
				str = "var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : ("
					+ doT.encodeHTMLSource.toString() + "(" + (c.doNotSkipEncoded || '') + "));"
					+ str;
			}
			try {
				return new Function(c.varname, str);
			} catch (e) {
				/* istanbul ignore else */
				if (typeof console !== "undefined") console.log("Could not create a template function: " + str);
				throw e;
			}
		};
	
		doT.compile = function(tmpl, def) {
			return doT.template(tmpl, null, def);
		};
	}());


/***/ })

/******/ });


// WEBPACK FOOTER //
// app/newIndex/assets/newIndex.bundle.js